import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IcMicOff16Icon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { IconView, IconViewSizes } from '@gem/ui-kit';
import { getMascotImageSrc } from '@gem/utils';

import { BrandBackground } from 'APP/components/BrandBackground/BrandBackground';
import { WrapperContent } from 'APP/unauthorized/Pages/Components/WrapperContent/WrapperContent';

import { ICallPreviewPresenter } from '../CallPreview.presenter';
import { StartCall } from '../StartCall/StartCall';
import styles from './WebinarInvitation.styles.m.css';

interface IWebinarInvitationProps {
  presenter: ICallPreviewPresenter;
}

// TODO: layout рассмотреть в будущем использование AuthorizationLayout
export const WebinarInvitation: FC<IWebinarInvitationProps> = observer(({ presenter }) => {
  const { t } = useTranslation();
  const { mainBackgroundLight, mainBackgroundDark, callInvitaion } = PROJECT_CONFIG.imageAssets;
  return (
    <>
      <BrandBackground
        isDarkMode={presenter.isDarkMode}
        backgroundSrc={{
          light: getMascotImageSrc(mainBackgroundLight),
          dark: getMascotImageSrc(mainBackgroundDark),
        }}
      />
      <WrapperContent>
        <div className={styles.logo}>
          <img
            src={getMascotImageSrc(callInvitaion)}
            alt="Call Invitation"
            width={104}
            height={104}
          />
        </div>
        <h1 className={styles.title}>{t('webinar_join_modal_title')}</h1>
        {presenter.isWaitingRoomEnabled && (
          <div className={styles.subtitle}>{t('webinar_join_modal_subtitle')}</div>
        )}
        <StartCall
          showDescription={false}
          isLoading={presenter.isLoading}
          waitingRoomMemberStatus={presenter.waitingRoomMemberStatus}
          onStart={presenter.onStart}
          onCancel={presenter.onCancel}
          className={styles.startCall}
        />
        <div className={styles.description}>
          <p>{t('webinar_listen_only_description_prefix')}</p>
          <div className={styles.listenOnly}>
            <IconView
              Icon={IcMicOff16Icon}
              size={IconViewSizes.XSmall}
              className={styles.micIcon}
            />
            {t('webinar_listen_only_mode')}
          </div>
        </div>
      </WrapperContent>
    </>
  );
});
